import React, { useEffect, useState } from "react";
import moment from "moment";

import { isEmptyObj } from "../../common/common";
import { InsuranceBlack, InsuranceGreen } from "../../common/svg";

const InsuranceTrip = ({ trip, showInsuranceForm }) => {
	const { id, insSupport, status, insActiveInfo, insReady, insAutoTs } = trip;

	const [content, setContent] = useState({});

	useEffect(() => {
		setContent(renderInsurance());
	}, [trip]);

	const renderInsurance = () => {
		if (insSupport < 1 && (status <= 5 || status === 25)) {
			return {
				className: "disable",
				icon: <InsuranceBlack />,
				text: "Chuyến không hỗ trợ gói bảo hiểm",
				func: null,
			};
		} else if (insSupport === 1) {
			if (!insActiveInfo && insReady === 0 && status < 4) {
				return {
					className: "warning",
					icon: <InsuranceBlack />,
					text: "Bảo hiểm sẽ tự động kích hoạt sau khi đặt cọc",
					func: null,
				};
			} else if (!insActiveInfo && status >= 4 && status < 20) {
				if (status < 5 && insReady === 0) {
					return {
						className: "upcoming",
						icon: <InsuranceBlack />,
						text: `Bảo hiểm sẽ được tự động kích hoạt vào ${moment(insAutoTs).format("DD/MM/YYYY HH:mm")}`,
						func: null,
					};
				} else {
					return {
						className: "upcoming",
						icon: <InsuranceBlack />,
						text: "Bảo hiểm đang chờ kích hoạt",
						func: null,
					};
				}
			} else if (insActiveInfo && (status < 20 || status === 25)) {
				return {
					className: "success",
					icon: <InsuranceGreen />,
					text: "Bảo hiểm đã được kích hoạt",
					func: () => showInsuranceForm(id, insActiveInfo.certNo),
				};
			} else {
				return {};
			}
		} else {
			return {};
		}
	};

	return (
		<>
			{!isEmptyObj(content) && (
				<div className={`insurance ${content.className}`} onClick={content.func}>
					<div className="wrap-svg">{content.icon}</div>
					<div className="content">
						<p>{content.text}</p>
						{insSupport === 1 && ((status >= 4 && status < 20) || status >= 25) && insActiveInfo && (
							<div className="desc">Xem chi tiết</div>
						)}
					</div>
				</div>
			)}
		</>
	);
};

export default InsuranceTrip;
